import React from "react";
import "./smallBar.css";
import { Bar } from "react-chartjs-2";
import Dropdown from "./dropdown";

const SmallBar = ({ options, monthsConsumption, state, title, color, dropdown }) => {

  options = {
    responsive: true,

    plugins: {
      tooltip: {
        enabled: true, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        ticks: { color: "#6C757D", font: { size: 12 } },
        beginAtZero: true,
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  monthsConsumption = [
    200, 300, 269, 400, 600, 420, 333, 245, 500
  ];

  state = {
    data: {
      labels: [
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
        "APR"
      ],
      datasets: [
        {
        //   label: "",
          backgroundColor: color,
          borderColor: color,
          borderWidth: 1,
          data: monthsConsumption,
          borderRadius: 7, // Round the top edges of bars
          barThickness: 14, // Width of the bars
        },
      ],
    },
  };

  return (
    <div className="smallBar">
      <div className="title">
        <span>{title}</span>
        {dropdown && <Dropdown data={dropdown} />}
      </div>
      <Bar height="210px" width="363px" options={options} data={state.data} />
    </div>
  );
};

export default SmallBar;
